export const editPageModal = {
  extend: [
    '/edit-component-modal',
    '/add-page-modal',
  ],
  props: {
    onInit: (el, s) => {
      let pageKey = s.key
      if (!pageKey) {
        const route = el.call('getLastLocationPath')
        const isIndex = route === '/main' || route === '/index'
        pageKey = `/${(isIndex ? '/' : route).slice(1).replaceAll('..', '/')}`
      }
      const item = el.getItem(pageKey, 'pages')
      return item && s.quietReplace(item)
    },
  },
  ModalHeader: {
    title: 'Edit {{ key }} page',
    p: 'Fill initial settings and choose a template',
  },
};